interface EnvConfig {
	commitSHA: () => string
	baseApiUrl: () => string
	clerkPublishableKey: () => string
	flagsmithKey: () => string
	zendeskKey: () => string
	sentryDsn: () => string
	gitbookUrl: () => string
	helpSubdomain: () => string
}

const env = (k: keyof ImportMetaEnv) =>
	import.meta.env[k] ?? window.__ENV_CONFIG__?.[k]

const envConfig: EnvConfig = {
	commitSHA: () => env("APP_COMMIT_SHA"),
	baseApiUrl: () => env("APP_BASE_API_URL") ?? "",
	clerkPublishableKey: () => env("APP_CLERK_PUBLISHABLE_KEY"),
	flagsmithKey: () => env("APP_FLAGSMITH_KEY"),
	zendeskKey: () => env("APP_ZENDESK_KEY"),
	sentryDsn: () => env("APP_SENTRY_DSN"),
	gitbookUrl: () => env("APP_GITBOOK_URL"),
	helpSubdomain: () => env("APP_HELP_SUBDOMAIN") ?? "help.",
}

export { envConfig }
